export default function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        require: '^tabs',
        scope: {
            title: '@'
        },
        link(scope, element, attrs, tabsCtrl, transclude) {
            transclude(scope.$parent, contents => {
                tabsCtrl.addTab(scope.title, contents);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/tab.js